import { BaseApiService } from '@/shared/api/services/base.service';
import type { Style, StylesResponse } from '@/types/style';

class StylesService extends BaseApiService {
  async getStyles(): Promise<Style[]> {
    const response = await this.httpGet<StylesResponse>('/v1/styles');
    return response.data;
  }
}

export const stylesService = new StylesService();
